import React from 'react';
import { useNavigate } from 'react-router-dom';
import theme from '../assets/theme';
import CustomTitle from './CustomTitle';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Flex } from 'antd';
import { navigateBackToShipmentDetail } from '../pages/Shipments/utils/navigateToExternalMapView';

interface AuthHeaderProps {
  bgColor?: string;
  color?: string;
  logo?: string;
  isMapPage?: boolean;
  isSharePage?: boolean;
  currentView?: string;
  setCurrentView?: (value: string) => void;
  returnShipmentId?: string | null;
  legType?: string;
}

/**
 * AuthHeader component that renders the authentication header with logo, navigation, and view controls
 *
 * @param bgColor - Background color for the header
 * @param color - Text color for the header
 * @param logo - Logo image source
 * @param isMapPage - Whether this is displayed on a map page (shows back arrow and radio buttons)
 * @param isSharePage - Whether this is displayed on a share page (affects logo display)
 * @param currentView - Current view selection ('summary' or 'detail')
 * @param setCurrentView - Function to update the current view
 * @param companyId - Company ID for conditional rendering
 */
const AuthHeader: React.FC<AuthHeaderProps> = ({
  bgColor,
  color,
  logo,
  isMapPage = false,
  isSharePage,
  returnShipmentId,
  legType,
}) => {
  const navigate = useNavigate();

  const goBackToShipment = (): void => {
    navigateBackToShipmentDetail(navigate, returnShipmentId, legType);
  };

  return (
    <section
      className='auth-header'
      style={{
        backgroundColor: bgColor,
        height: '64px',
      }}
    >
      {theme?.themeType === 1
        ? isSharePage === true && (
            <Flex
              gap={6}
              className='auth-header-logo-single auth-header-logo'
              align='center'
            >
              <img src={logo} alt='' className='header-zoomlogi-logo' />
              {/* shared  */}
              <CustomTitle
                text={theme.title}
                color={color}
                fontSize='20px'
                lineHeight='28px'
                fontWeight='700'
                marginBottom='0px'
              />
            </Flex>
          )
        : isSharePage === true && (
            <Flex gap={4} className='auth-header-logo-single auth-header-logo'>
              {theme?.themeType === 1 ? (
                <>
                  <img src={logo} alt='' />
                  <CustomTitle
                    text={theme.title}
                    color={color}
                    fontSize='20px'
                    lineHeight='28px'
                    fontWeight='700'
                    marginBottom='0px'
                  />
                </>
              ) : (
                <img
                  src={theme.whiteLogo}
                  className='theme-header-img'
                  width={theme.authHeaderLogoWidth}
                  style={
                    theme.whiteLogoFilter
                      ? { filter: theme.whiteLogoFilter }
                      : undefined
                  }
                  alt={'Logo'}
                />
              )}
            </Flex>
          )}
      {isSharePage === false && (
        <Flex gap={6} className='auth-header-logo' align='center'>
          {theme?.themeType === 1 ? (
            <>
              <img src={logo} alt='' className='header-zoomlogi-logo' />
              {/* external / onboarding  */}
              <CustomTitle
                text={theme.title}
                color={color}
                fontSize='20px'
                lineHeight='28px'
                fontWeight='700'
                marginBottom='0px'
              />
            </>
          ) : (
            <img
              src={theme.whiteLogo}
              className='theme-header-img'
              width={theme.authHeaderLogoWidth}
              style={
                theme.whiteLogoFilter
                  ? { filter: theme.whiteLogoFilter }
                  : undefined
              }
              alt={'logo'}
            />
          )}
        </Flex>
      )}

      {isMapPage && !isSharePage && (
        <ArrowLeftOutlined
          style={{ position: 'absolute', left: '20px', color: '#fff' }}
          onClick={goBackToShipment}
          className='header-back-arrow'
        />
      )}

      {/* {isMapPage && (
        <Flex className='zl-summary-detail-switch' gap={16}>
          <Radio.Group
            value={currentView}
            onChange={(e) => setCurrentView?.(e.target.value)}
            style={{
              border: '1px solid var(--light-blue)',
              borderRadius: '7px',
            }}
          >
            <Radio.Button
              className='radio-btn-group'
              style={{ border: 0 }}
              value='summary'
            >
              Summary
            </Radio.Button>
            <Radio.Button
              className='radio-btn-group'
              style={{ border: 0 }}
              value='detail'
            >
              Detailed
            </Radio.Button>
          </Radio.Group>
        </Flex>
      )} */}
    </section>
  );
};

export default AuthHeader;
